import withModalShow from './hoc/withModalShow'
import { useDispatchModal } from './hooks/useDispatchModal'
import { useReadModal } from './hooks/useReadModal'
import type { ModalDefaultProps, ModalDefinitionParams } from './types'

export function defineModal<T extends ModalDefaultProps = any>({
  name
}: ModalDefinitionParams) {
  return {
    useDispatchModal: () => useDispatchModal<T>({ name }),
    withModalShow: withModalShow({ name }),
    useModal: () => {
      const read = useReadModal<T>({ name })
      const dispatch = useDispatchModal<T>({ name })
      return { ...read, ...dispatch }
    }
  }
}
